module.exports = __webpack_public_path__ + "static/img/bg_discount_no.6d2e074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_discount_no.png
// module id = pFpo
// module chunks = 192